import { AfterViewChecked, ChangeDetectionStrategy, Component, inject, OnDestroy, OnInit, signal, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NoItemComponent, PageLayoutComponent, SearchComponent } from '@client-monorepo/common/ui-components';
import { GroupedAppServicesComponent } from '@client-monorepo/common/app-services';
import { rangeCreator } from '@client-monorepo/common/utilities';
import { SearchResultComponent } from '../../components/search-result/search-result.component';
import {
  AppService,
  AppServiceCategoryNamesEnum,
  appServicesCategoriesConst,
  FrequentServiceInterface,
} from '@client-monorepo/common/service-data';
import { Router } from '@angular/router';
import { NgxBottomNavigationService } from '@digipay/ngx-bottom-navigation';

@Component({
  selector: 'hub-applet-hub-search',
  standalone: true,
  imports: [CommonModule, SearchComponent, GroupedAppServicesComponent, SearchResultComponent, NoItemComponent, PageLayoutComponent],
  templateUrl: './hub-search.component.html',
  styleUrl: './hub-search.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HubSearchComponent implements OnInit, OnDestroy, AfterViewChecked {
  appServiceService = inject(AppService);
  servicesLoading = signal(true);
  services = signal<Array<FrequentServiceInterface>>([]);
  showingServices = signal<Array<FrequentServiceInterface>>([]);
  appServicesCategoriesConst = appServicesCategoriesConst;
  AppServiceCategoryNamesEnum = AppServiceCategoryNamesEnum;
  searchText = signal<string>('');
  searching = signal<boolean>(false);
  searched = signal<boolean>(false);
  rangeCreator = rangeCreator;
  router = inject(Router);
  bottomNavigationService = inject(NgxBottomNavigationService);
  searchComponent = viewChild<SearchComponent>('searchComponent');
  initialized = signal(false);

  ngOnInit() {
    this.getServices();
    this.bottomNavigationService.hide();
  }

  ngOnDestroy() {
    this.bottomNavigationService.show();
  }

  ngAfterViewChecked() {
    if (this.searchComponent()?.searchEl() && !this.initialized()) {
      this.searchComponent()?.searchEl()?.nativeElement.focus();
      this.initialized.set(true);
    }
  }

  getServices(): void {
    this.appServiceService.getMappedServices().subscribe({
      next: (services) => {
        this.services.set(services);
        this.servicesLoading.set(false);
      },
    });
  }

  clickOnService(service: FrequentServiceInterface): void {
    this.searchText.set(service.title);
    this.doSearch(this.searchText());
  }

  normalizeText(text: string): string {
    if (!text) return '';
    return text.replace(/\u200c/g, ' ').toLowerCase();
  }

  doSearch(searchText = ''): void {
    this.searching.set(true);

    const normalizedSearchText = this.normalizeText(searchText);

    if (normalizedSearchText && normalizedSearchText.length > 2 && this.services().length) {
      this.showingServices.set(
        this.services().filter((service) => {
          const normalizedTitle = this.normalizeText(service.title);
          const normalizedTags = service.tags?.map((tag) => this.normalizeText(tag));

          return normalizedTitle.includes(normalizedSearchText) || normalizedTags?.some((tag) => tag.includes(normalizedSearchText));
        }),
      );
      this.searching.set(false);
      this.searched.set(true);
    } else {
      this.showingServices.set([]);
      this.searching.set(false);
      this.searched.set(false);
    }
  }

  handleResultClick(service: FrequentServiceInterface) {
    // @todo: implement action logic
  }

  handleBack(): void {
    this.router.navigate(['/hub']);
  }
}
